import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setDocumentTitle } from "@/utils/document-title.utils";

/** Keeps the browser tab title in sync with the current route. */
export function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    setDocumentTitle(pathname);
  }, [pathname]);

  return null;
}
